var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotsNotificationGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 4.73242C5.50736 4.73242 4.5 5.73978 4.5 6.98242C4.5 8.22506 5.50736 9.23242 6.75 9.23242C7.99264 9.23242 9 8.22506 9 6.98242C9 5.73978 7.99264 4.73242 6.75 4.73242ZM2.5 6.98242C2.5 4.63521 4.40279 2.73242 6.75 2.73242C9.09721 2.73242 11 4.63521 11 6.98242C11 9.32963 9.09721 11.2324 6.75 11.2324C4.40279 11.2324 2.5 9.32963 2.5 6.98242Z",
    fill: "#B4B1B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 4.73242C16.0074 4.73242 15 5.73978 15 6.98242C15 8.22506 16.0074 9.23242 17.25 9.23242C18.4926 9.23242 19.5 8.22506 19.5 6.98242C19.5 5.73978 18.4926 4.73242 17.25 4.73242ZM13 6.98242C13 4.63521 14.9028 2.73242 17.25 2.73242C19.5972 2.73242 21.5 4.63521 21.5 6.98242C21.5 9.32963 19.5972 11.2324 17.25 11.2324C14.9028 11.2324 13 9.32963 13 6.98242Z",
    fill: "#B4B1B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 15.2324C5.50736 15.2324 4.5 16.2398 4.5 17.4824C4.5 18.725 5.50736 19.7324 6.75 19.7324C7.99264 19.7324 9 18.725 9 17.4824C9 16.2398 7.99264 15.2324 6.75 15.2324ZM2.5 17.4824C2.5 15.1352 4.40279 13.2324 6.75 13.2324C9.09721 13.2324 11 15.1352 11 17.4824C11 19.8296 9.09721 21.7324 6.75 21.7324C4.40279 21.7324 2.5 19.8296 2.5 17.4824Z",
    fill: "#B4B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 15.2324C16.0074 15.2324 15 16.2398 15 17.4824C15 18.725 16.0074 19.7324 17.25 19.7324C18.4926 19.7324 19.5 18.725 19.5 17.4824C19.5 16.2398 18.4926 15.2324 17.25 15.2324ZM13 17.4824C13 15.1352 14.9028 13.2324 17.25 13.2324C19.5972 13.2324 21.5 15.1352 21.5 17.4824C21.5 19.8296 19.5972 21.7324 17.25 21.7324C14.9028 21.7324 13 19.8296 13 17.4824Z",
    fill: "#B4B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsNotificationGray);
export default __webpack_public_path__ + "static/media/DotsNotificationGray.8db80bdb74cbc090842ca47c7eff9e78.svg";
export { ForwardRef as ReactComponent };